import getTableCellsTillBreak from './getTableCellsTillBreak';
export default function getTableColumnCountForCells(cells) {
  // Dummy algorithm, we only count the first row here. Might broke is table is
  // not consistent
  return getTableCellsTillBreak(cells).size;
}